import { render, staticRenderFns } from "./CustomerFilterOptions.vue?vue&type=template&id=0bbf4670&scoped=true&"
import script from "./CustomerFilterOptions.vue?vue&type=script&lang=js&"
export * from "./CustomerFilterOptions.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFilterOptions.vue?vue&type=style&index=0&id=0bbf4670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf4670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbf4670')) {
      api.createRecord('0bbf4670', component.options)
    } else {
      api.reload('0bbf4670', component.options)
    }
    module.hot.accept("./CustomerFilterOptions.vue?vue&type=template&id=0bbf4670&scoped=true&", function () {
      api.rerender('0bbf4670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerFilterOptions.vue"
export default component.exports